var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "audio",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.867,
    height: 58.88,
    viewBox: "0 0 58.867 58.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4513"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M660.938-457.024c-.006-2.629-.714-3.132-3.317-2.4q-9.162,2.576-18.317,5.173c-6.55,1.856-6.549,1.86-6.088,8.727v17.489c-.841-.23-1.379-.393-1.888-.52a6.842,6.842,0,0,0-8.442,7.811,6.942,6.942,0,0,0,7.674,5.722,6.994,6.994,0,0,0,6.083-7.192c.057-6.885.007-13.771,0-20.657q9.624-2.83,19.249-5.664c1.26-.372,1.734-.015,1.579,1.7a47.221,47.221,0,0,0-.077,9.053c.247,2.419.042,2.765-1.491,2.4-3.665-.884-6.86.677-8.149,3.77a6.685,6.685,0,0,0,1.383,7.662,6.625,6.625,0,0,0,7.2,1.653,6.7,6.7,0,0,0,4.625-6.677Q660.98-443,660.938-457.024Z",
    transform: "translate(-602.099 473.852)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M626.376-461.258c-4.305-3.543-8.4-7.2-11.252-12.075a1.667,1.667,0,0,0-2.106-.847,1.823,1.823,0,0,0-1.213,1.945c.042,1.569.059,3.139.086,4.709v21.764c-.509-.109-.73-.14-.942-.2-3.455-1.04-6.328-.208-8.18,2.375a6.828,6.828,0,0,0-.062,7.973,6.762,6.762,0,0,0,7.068,2.786c3.663-1.083,5.534-3.372,5.546-7.123.026-8.753-.038-17.507-.065-26.26,3.079,2.667,6.367,5.132,9.174,8.057,2.615,2.725.643,7.454-3.168,8.082-1.371.226-2.752.437-2.5,2.121.271,1.843,1.881,1.71,3.217,1.393a8.606,8.606,0,0,0,6.4-5.3C629.706-455.319,629.362-458.8,626.376-461.258Z",
    transform: "translate(-601.453 474.294)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioHome);
export default __webpack_public_path__ + "static/media/audioHome.90a780d01b9f42ff92f708c7eb5afafc.svg";
export { ForwardRef as ReactComponent };